import { render } from "./PortfolioDetails.vue?vue&type=template&id=3439156c&ts=true"
import script from "./PortfolioDetails.vue?vue&type=script&lang=ts"
export * from "./PortfolioDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__